import { Grid } from 'antd';

const useIsMobile = () => {
  const screens = Grid.useBreakpoint();

  return !screens.lg;
};

export default useIsMobile;
